import { Crop } from 'react-image-crop'

export const getCroppedImage = async (
  image: HTMLImageElement,
  crop: Crop,
  type: 'png' | 'jpeg',
): Promise<Blob | null> => {
  const canvas = document.createElement('canvas')

  // Convert percentage crop to pixel crop
  const pixelCrop = {
    unit: 'px',
    x: (crop.x / 100) * image.width,
    y: (crop.y / 100) * image.height,
    width: (crop.width / 100) * image.width,
    height: (crop.height / 100) * image.height,
  }

  const scaleX = image.naturalWidth / image.width
  const scaleY = image.naturalHeight / image.height

  canvas.width = pixelCrop.width
  canvas.height = pixelCrop.height
  const canvasContext = canvas.getContext('2d')

  if (canvasContext) {
    canvasContext.imageSmoothingQuality = 'high'
    canvasContext.drawImage(
      image,
      pixelCrop.x * scaleX,
      pixelCrop.y * scaleY,
      pixelCrop.width * scaleX,
      pixelCrop.height * scaleY,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height,
    )

    return new Promise((resolve) => {
      canvas.toBlob((blob) => resolve(blob), `image/${type}`, 1)
    })
  }
  return null
}
